import { useEffect, useRef, useCallback } from 'react';

export const useInfiniteScroll = (fetchNextPage, hasNextPage, isFetchingNextPage, hasData) => {
  const loadMoreRef = useRef(null);
  const observerRef = useRef(null);

  const handleObserver = useCallback((entries) => {
    if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    if (!hasData || !loadMoreRef.current) return;

    observerRef.current = new IntersectionObserver(handleObserver, {
      threshold: 0.1,
      rootMargin: '50px',
    });

    observerRef.current.observe(loadMoreRef.current);

    return () => observerRef.current?.disconnect();
  }, [handleObserver, hasData]);

  return { loadMoreRef };
};